//this is based on the answer by ford04 on https://stackoverflow.com/questions/38688822/how-to-parse-json-string-in-typescript
export type ParseResult<T> =
  | { parsed: T; hasError: false; error?: undefined }
  | { parsed?: undefined; hasError: true; error?: unknown }

export const parseFromString = <T>(guard: (o: unknown) => o is T) => (
  text: string,
): ParseResult<T> => {
  try {
    const parsed = JSON.parse(text)
    return guard(parsed) ? { parsed, hasError: false } : { hasError: true }
  } catch (e) {
    return { hasError: true, error: e }
  }
}
